import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataStoreService {
  private _allStepsData = {};
  private countryCode: string;
  private selectedValue = {};
  private allStepData;
  private type;
  set(name: string, data): void {
    try {
      this._allStepsData['' + name] = JSON.parse(JSON.stringify(data, this.replacer, 4));
    } catch (error) {
      console.log(error);
    }
  }
  replacer(key: string, value: any) {
    let valueAsString = value;
    if (this[key] instanceof Date || typeof this[key] === 'function') {
      valueAsString = this[key].toString();
    } else if (key === 'refElement' || key === 'containerRef' || key === 'componentRef') {
      this[key] = undefined;
    }

    if (key === 'customValidators') {
      return undefined;
    }

    return this[key] === undefined ? null : valueAsString;
  }

  get(name: string): any {
    return this._allStepsData['' + name];
  }

  clear(): void {
    this._allStepsData = {};
  }



  setDataClear() {
    this.allStepData = {};
    this.type = null;
    this._allStepsData = {};
  }

  setCountryCode(countryCode): void {
    this.countryCode = countryCode;
  }

  getCountryCode(): string {
    return this.countryCode;
  }
  getAllStepData(): Array<any> {
    return this.allStepData;
  }


  setAllStepData(allStepData): void {
    this.allStepData = allStepData;
  }
  setType(type: string) {
    this.type = type;
  }
  getType() {
    return this.type;
  }
  clearPaymentDocument(): void {
    delete this._allStepsData['' + 'fnol-payment-details']
    delete this._allStepsData['' + 'fnol-upload-docs']
  }
  setSelectedData(selectedValue): void {
    this.selectedValue = selectedValue;
  }
  getSelectedData() {
    return this.selectedValue;
  }
  constructor() { }
  checkAutoComplete(value) {
    if (typeof value === 'object' && value.autoCompleteAddress) {
      return (value['name'] || value.autoCompleteAddress)
    } else {
      return value
    }
  }
}
